module.exports = __webpack_public_path__ + "static/nas.6685b035.png";